import { CardsEnum } from "../shared/constants/CardsEnum";
import { Alia, Amex, Carnet, Dinners, Discover, JCB, Mastercard, Visa, } from "../assets/logos";
export var getCardBrand = function (brand) {
    switch (brand) {
        case CardsEnum.visa:
            return { image: Visa, value: brand };
        case CardsEnum.mastercard:
            return { image: Mastercard, value: brand };
        case CardsEnum.amex:
            return { image: Amex, value: brand };
        case CardsEnum.alia:
            return { image: Alia, value: brand };
        case CardsEnum.diners:
            return { image: Dinners, value: brand };
        case CardsEnum.discover:
            return { image: Discover, value: brand };
        case CardsEnum.jcb:
            return { image: JCB, value: brand };
        case CardsEnum.carnet:
            return { image: Carnet, value: brand };
        default:
            return undefined;
    }
};
export var checkTermsAndConditions = function (formDataTerms, termsAndConditions) {
    if (!termsAndConditions)
        return true;
    return formDataTerms;
};
export var validateCardNumber = function (cardNumber) {
    if (cardNumber.length === 8 ||
        cardNumber.length >= 13 ||
        cardNumber.length === 0) {
        return true;
    }
    return false;
};
